<template>
    <div class="edit-user">

            <div class="card">
                <div class="card-header">
                    <h5 class="card-title text-center" v-if="user && !user.AppUserId">Add User</h5>
                    <h5 class="card-title text-center" v-if="user && user.AppUserId">Edit User</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <div class="row mb-2">
                        <BasicTextInput label="First Name"
                                        v-model="user.FirstName"
                                        :validator="$v.user.FirstName"
                                        :validatorMsgMap="validatorMsgMapBase"
                                        class="col-6" />
                        <BasicTextInput label="Last Name"
                                        v-model="user.LastName"
                                        :validator="$v.user.LastName"
                                        :validatorMsgMap="validatorMsgMapBase"
                                        class="col-6" />
                    </div>

                    <div class="row mb-2">
                        <!-- <PhoneNumberInput label="Phone" class="col-6" v-model="user.MobilePhone" /> -->
												<BasicTextInput   label="Email / Logon"
																					name="notASearchField"
																					class="col-6"
																					type="search"
																					autocomplete="off"
																					:validator="$v.user.Email"
																					:validatorMsgMap="validatorMsgMapBase"
																					@input="updateEmailToLowerCase"
																					v-model="user.Email"       />

												<div class="col-6" v-if="can('access-user-lockout')">
													<div class="d-flex justify-content-center  align-items-center">
															<div class="user-locked-state">Logon: <span :class="lockoutStatusClass">{{ lockoutStatus }}</span></div>
															<!-- The billing tier used to be set here in the browser; it is now derived
																   on the server when the change is saved. -->
															<ToggleSwitch v-model="user.IsLockedOut" class="user-locked-state-toggle"/>
													</div>
                        </div>


                    </div>

                    <!-- <div class="row mb-2">
                        <BasicTextInput label="Address" class="col-8" v-model="user.AddressLine1" />
                        <BasicTextInput label="Suite"   class="col-4" v-model="user.AddressLine2" />
                    </div>

                    <div class="row mb-2">
                        <BasicTextInput label="City"         class="col-4"  v-model="user.City"/>
                        <StateSelect    label="Select State" class="col-4"  v-model="user.StateProvinceId" />
                        <ZipCodeInput   label="Zip Code"     class="col-4"  v-model="user.ZipCode" />
                    </div> -->

                    <div class="row mb-2">
                        <RoleSelect    v-model.number="user.UserRoleId"
                                       :disabled="userPersisted"
                                       :roles="roles"
                                       class="col-6" label="Role" />
                        <ManagerSelect v-model="user.ManagerId"
                                       class="col-6"
                                       label="Manager"
                                       :disabled="selectedUserIsNotSalesRep"
                                       v-if="hasManagerSelectAuthority"
                                       :potentialManagers="potentialManagers"/>
                    </div>

                    <div class="row mb-2">
                        <div class="col-6">
                            <label><b>Groups</b></label>
                            <div class="form-group">
                                <v-select label="Name"
                                          v-model="user.GroupIds"
                                          multiple
                                          :disabled="user.CanAccessAllGroups"
                                          :options="groupOptions" :reduce="group => group.Id"
                                          class="group-select" />
                            </div>
                        </div>
												<div class="col-6">
													<label><b>User Type</b></label>
													<div class="form-group">
														<!-- Read-only: the billing tier is derived server-side from role, activation
														     state and the account flags below. Changed only by automation or SQL.
														     While the flags are being edited it shows the server's preview of the tier
														     the save would store. -->
														<input type="text"
																	 class="form-control"
																	 :value="userTypeDisplay"
																	 readonly
																	 disabled
																	 aria-label="User Type" />
														<small class="form-text text-muted" v-if="userTypeChangesOnSave">Takes effect when you click Update User</small>
													</div>
												</div>

										</div>

										<div class="row mb-2">
													<div class="col-6">
                            <Checkbox label="All Groups" :value="user.CanAccessAllGroups" @input="onChargeableChange('CanAccessAllGroups', $event)" />
                        </div>
												<div class="col-6">
                            <Checkbox label="Is Visible To All Reps"  v-model="user.IsVisibleToAllReps" />
                        </div>
										</div>

										<div class="row mb-2">
												<div class="col-6">
                            <!-- Only admins may change this (DCSS-372); for anyone else the save ignores it. -->
                            <Checkbox label="Can View All Orders" :value="user.CanViewAllOrders" :disabled="!canChangeViewAllOrders" @input="onChargeableChange('CanViewAllOrders', $event)" />
                        </div>
												<div class="col-6">
                            <Checkbox label="Limited/Transfer User" v-model="user.IsLimitedTransferUser" />
                        </div>
										</div>

										<div class="row mb-2">
                        <div class="col-6">
                            <Checkbox label="Can Upload Configurators" v-model="user.CanUploadConfigurators" />
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-6">
                            <div class="d-flex justify-content-center  align-items-center">
                                <button class="btn btn-secondary btn-block" v-if="userId && !user.EmailConfirmed" @click="resendEmail">Resend Activation Email</button>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <button class="btn btn-primary btn-block" v-if="user && !user.AppUserId" @click="createUser">Create User</button>
                        <button class="btn btn-primary btn-block" v-if="user && user.AppUserId"  @click="updateUser">Update User</button>
                    </div>
                </div>
            </div>

        <Modal ref="chargeModal" :disable_background_click_to_close="true" wrapper_classes="position-absolute">
            <div class="p-4 text-center" style="max-width:420px">
                <p class="mb-4">If saved, the changes you have made will result in increased charges for this user</p>
                <div class="d-flex justify-content-center">
                    <button class="btn btn-secondary mr-3" @click="onChargeDialogCancel">Cancel</button>
                    <button class="btn btn-primary"         @click="onChargeDialogAccept">Accept</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import { UserService, DealerService }         from '@/services';
    import { mapState }            from 'vuex';
    import { validatorMsgMapBase } from "@/modules/helpers";
    import {
        required,
        email,
    }                              from 'vuelidate/lib/validators';
    import {
        userRoleEnum,
        getKeyByValue
    }                              from "../../../modules/helpers";

    export default {
        name: "DealerUsersEdit",
        data: () => {
            return {
                validatorMsgMapBase: validatorMsgMapBase,
                user: {
									FirstName: '',
									LastName:  '',
									MobilePhone: '',
									Email: '',
									EmailToLowerCase: '',
									AddressLine1 : '',
									AddressLine2 :  '',
									City: '',
									StateProvinceId : null,
									ZipCode : null,
									UserRoleId: -1,
									ManagerId: null,
									GroupIds: [],
									IsLockedOut: false,
									CanUploadConfigurators: false,
									// Derived server-side. A new account starts life not activated; the
									// label is replaced with whatever the server resolves on save.
									UserType: 0,
									UserTypeDisplayName: 'Not Billed - Not Activated',
                },
                chargePendingField: null,
                // Label of the tier the unsaved edits would resolve to; null shows the stored one.
                userTypePreview: null,
                // userTypeInputs the box currently reflects (requested, or loaded); a reload is not an edit.
                previewedUserTypeInputs: null,
                // Increments per preview request so a slow, superseded response is discarded.
                userTypePreviewSeq: 0,
            }
        },
        props: {
            userId: {
                type: Number,
                default: null,
            },
            users: {
               type: Array,
            },
            groups: {
               type: Array,
            }
        },
        computed: {
            ...mapState(['currentUser']),
            updateEmailToLowerCase(){
                this.user.EmailToLowerCase = this.user.Email.toLowerCase();
            },
            potentialManagers(){
                // only sales reps will have managers, and only Sales Manager will be their managers, so just return a list of sales managers...
                return this.users.filter(du => du.UserRoleId === 3); // 3 === 'Sales Manager'
            },
            selectedUserIsNotSalesRep(){
                return this.user.UserRoleId !== 4;
            },
            userPersisted(){
                return !!this.user.AppUserId;
            },
            // Mirrors UserTypeInputs.ApplyBillingFlags on the server.
            canChangeViewAllOrders(){
                let role = getKeyByValue(userRoleEnum,this.currentUser.UserRoleId);
                return role === 'SmartSales Admin' || role === 'Sales Administrator';
            },
            hasManagerSelectAuthority(){
                let role = getKeyByValue(userRoleEnum,this.currentUser.UserRoleId);
                if ( role === 'SmartSales Admin'   ) return true;
                if ( role === 'Sales Administrator') return true;
                return false;
            },
            groupOptions(){
                return this.groups.sort(function(a, b) {
                    var textA = a.RegionCode.toUpperCase();
                    var textB = b.RegionCode.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            },
            roles(){
                let role = getKeyByValue(userRoleEnum,this.currentUser.UserRoleId);

                if (role === 'SmartSales Admin') {
                    return Object.entries(userRoleEnum).filter(([k,v]) => v >=  2); // can create Sales Administrators and Lesser Users
                } else if (role === 'Sales Administrator'){
                    return Object.entries(userRoleEnum).filter(([k,v]) => v >=  2); // can create Sales Administrators and Lesser Users
                } else if (role === 'Sales Manager') {
                    return Object.entries(userRoleEnum).filter(([k,v]) => v === 4); // can create Sales Reps
                }

            },
						// The server owns the billing tier and sends its label with the profile, so the
						// list of types is deliberately not duplicated here any more.
						userTypeDisplay(){
								return this.userTypePreview || this.user.UserTypeDisplayName || 'Not Set';
						},
						userTypeChangesOnSave(){
								return !!this.userTypePreview && this.userTypePreview !== this.user.UserTypeDisplayName;
						},
						// Everything in the editor that can move the tier. Activation state and the stored
						// tier also count, but the server reads those itself.
						userTypeInputs(){
								const u = this.user;
								return [u.UserRoleId, u.IsLockedOut, u.CanAccessAllGroups, u.CanViewAllOrders, u.IsLimitedTransferUser].join('|');
						},
            lockoutStatusClass(){
                return this.user.IsLockedOut ? 'text-danger' : 'text-success';
            },
            lockoutStatus(){
                return this.user.IsLockedOut ? 'DISABLED' : 'ENABLED' ;
            }
        },
        methods: {
            removeGroupsSelected(){
                this.user.GroupIds = [];
            },
            onChargeableChange(field, value) {
                if (value === true) {
                    this.user[field] = true;
                    this.chargePendingField = field;
                    this.$refs.chargeModal.openModal();
                } else {
                    this.user[field] = false;
                }
            },
            onChargeDialogCancel() {
                this.user[this.chargePendingField] = false;
                this.chargePendingField = null;
                this.$refs.chargeModal.closeModal();
            },
            onChargeDialogAccept() {
                const field = this.chargePendingField;
                this.user[field] = true;
                if (field === 'CanAccessAllGroups') {
                    this.removeGroupsSelected();
                }
                this.chargePendingField = null;
                this.$refs.chargeModal.closeModal();
                // The flag was already set when the dialog opened, so the watcher skipped it.
                this.refreshUserTypePreview();
            },
            refreshUserTypePreview(){
                // A new account is always "Not Activated" until sign-up; nothing to preview.
                if (!this.userPersisted) return;

                // Accept and the watcher can both ask for the same values; one request is enough.
                const inputs = this.userTypeInputs;
                if (inputs === this.previewedUserTypeInputs) return;
                this.previewedUserTypeInputs = inputs;

                const seq = ++this.userTypePreviewSeq;

                // Always ask, even when the edits are undone back to the loaded values: the stored
                // tier may predate the automation (e.g. Not Set before the backfill), so it is not
                // necessarily what a save of those values would store.
                UserService.previewUserType(this.user)
                    .then(res => {
                        if (seq === this.userTypePreviewSeq) this.userTypePreview = res.UserTypeDisplayName;
                    })
                    .catch(err => {
                        // The preview is advisory: fall back to the stored tier; the save still resolves it.
                        console.log('err', err);
                        if (seq === this.userTypePreviewSeq) {
                            this.userTypePreview = null;
                            this.previewedUserTypeInputs = null; // let the next edit try again
                        }
                    });
            },
            resendEmail(){
                UserService.resendActivationEmail(this.user.AppUserId)
                    .then(res => {
                        console.log('res', res)
                        this.$store.dispatch('ADD_NOTIFICATION', { text: `Activation email has been sent to ${this.user.Email}`, type: 'success'});
                    })
                    .catch(err => {
                        console.log('err', err)
                        this.$store.dispatch('ADD_NOTIFICATION', { text: `Activation email was not able to send to ${this.user.Email} at this time`, type: 'error'});
                    })
            },
            updateUser(){
                this.$v.user.$touch();
                if (this.$v.user.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }

                let user = this.handleManagerSetup(this.user);

                // let promises = [];
                // if (user.IsLockedOut){
                //     promises.push(UserService.lock(user.AppUserId))
                // } else {
                //     promises.push(UserService.unlock(user.AppUserId))
                // }

                // promises.push(UserService.update(user));

                // Promise.all(promises)
                UserService.update(user).then(res => {
                    console.log('res', res)
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'User Updated', type: 'success'});
                    // The User Type box is read-only and the tier is resolved during the save, so
                    // re-read the profile to show the resulting tier rather than the stale one.
                    this.getUser();
                    this.$emit('update:success');
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                })
            },
            createUser(){
                this.$v.user.$touch();
                if (this.$v.user.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }

                let user = this.handleManagerSetup(this.user);

                UserService.create(this.$route.params.id, user).then(res => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'User Created', type: 'success'});
                    this.$emit('update:success');
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                })
            },
            handleManagerSetup(user){
                let currentUserRole = getKeyByValue(userRoleEnum,this.currentUser.UserRoleId);
                if (currentUserRole === 'Sales Manager'){
                    user.ManagerId = this.currentUser.SalesRepId;
                }
                if (user.ManagerId === 0){
                    user.ManagerId = null;
                }

                return user;
            },
            getUser(){
                const dealerId = this.$route.params.id;
                const userId = this.userId;
                if(!this.userId) return;
                DealerService.salesRep(dealerId, userId)
                    .then(res => {
                        //console.debug('USER: ', res);
                        this.user = res;
                        this.user.EmailToLowerCase = "";
                        // Fresh from the server: the stored tier is current again.
                        this.previewedUserTypeInputs = this.userTypeInputs;
                        this.userTypePreview = null;
                        this.userTypePreviewSeq++;
                    })
                    .catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                    })
            }
        },
        validations: {
            user: {
                FirstName: {
                    required,
                },
                LastName: {
                    required,
                },
                EmailToLowerCase: {
                    required,
                    email,
                },
                Email: {
                    required,
                    email,
                }
            },
        },
        watch: {
            'user.UserRoleId': function (newRoleId,oldRoleId){
                if (newRoleId !== 4){
                    this.$nextTick(() => {
                        this.user.ManagerId = null;
                    })
                }
            },
            userTypeInputs(){
                // While the charge dialog is open the flag is only tentatively set: Accept previews
                // it explicitly and Cancel reverts it, which re-triggers this watcher.
                if (this.chargePendingField) return;
                this.refreshUserTypePreview();
            }

        },
        created(){
            this.getUser();
        }
    }
</script>

<style scoped lang="scss">
    .edit-user {
        min-width: 900px;
        .group-select {
            background-color: $white;
						min-height: 50px;
        }
			.user-locked-state {
					min-width: 170px;
					margin-left: -180px;
					margin-top: 25px;
			}
			.user-locked-state-toggle {
					margin-top: 25px;
			}
		}
</style>
